import { render, staticRenderFns } from "./PodcastCreate.vue?vue&type=template&id=020b388f&"
import script from "./PodcastCreate.vue?vue&type=script&lang=js&"
export * from "./PodcastCreate.vue?vue&type=script&lang=js&"
import style0 from "./PodcastCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports